<template>
    <div>
        <section class="py-2 py-md-3">
            <div class="container py-2">
                <div class="breadcrumbs-retos">
                    <a href="/home-bat">
                        <img src="/img/icons/homeBread.svg" alt=""/>
                    </a>
                    <a class="link cursor-pointer" href="#" @click="returnView()">A la practica </a>
                    <a class="link cursor-pointer" href="#" @click="returnView()">Aprendizaje /</a>
                    <span class="color-active-miga"
                          v-if="learning !== null"><strong>Retroalimentación Quiz {{ learning.title }}</strong></span>
                </div>
                <a href="#" @click="returnView()"><img src="/img/icons/regresar.svg" alt="icon"></a>
            </div>
        </section>
        <section class="backBtn d-block d-md-none py-5">
            <a class="ps-3" href="/retos?learning"> < Ir a la práctica</a>
        </section>
        <div v-if="questions.length > 0">
            <div class="container text-bat">
                <h3 class="text-indigo-dark text-title-bat">¡Resultados!</h3>
                <p class="subtitle">Respondiste bien el [{{ Math.round(porcentajeAciertos()) }}%] del quiz</p>
            </div>

            <div class="container">
                <div class="container-result my-4">
                    <div class="card-feedback">
                        <div class="card-content-feedback">
                            <div class="section-divider-top">
                                <!-- <h4>Mínimo requerido</h4> -->
                                <h4>Mínimo requerido</h4>
                                <!-- <div class="value-percentage">75%</div> -->
                                <div class="value-percentage">{{ Math.round(learning.percentage_to_win) }}%</div>
                            </div>
                            <div class="section-divider-top">
                                <!-- <h4>Tu resultado</h4> -->
                                <h4>Tu resultado</h4>
                                <div class="value-percentage">{{ Math.round(porcentajeAciertos()) }}%</div>
                            </div>
                        </div>

                        <div class="section-divider-bottom">
                            <div class="item-divider">
                                <!-- <div class="label-status">Correctas</div> -->
                                <div class="label-status">Correctas</div>
                                <div class="number-status correct">{{ correct_answers }}</div>
                            </div>
                            <div class="item-divider">
                                <!-- <div class="label-status">Incorrectas</div> -->
                                <div class="label-status">Incorrectas</div>
                                <div class="number-status incorrect">{{ incorrect_answers }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container text-bat my-4">
                <div class="row">
                    <div v-for="question in questions" :key="question.id"  class="col-12 col-md-6 col-lg-6 col-xl-4">
                        <!-- Pregunta seleccion multiple correcta Inicio -->
                        <div class="feedback-box shadow mb-4 mb-md-3" :class="{'feedback-border-success': isAnswerCorrect(question), 'feedback-border-danger': !isAnswerCorrect(question)}">
                            <div class="content-feedback mb-2 py-2 px-3">
                                <!-- <span v-if="isAnswerCorrect(question)" class="text-white bg-success fs-7 px-2 py-1 rounded-4 text-title-bat"> -->
                                <span v-if="isAnswerCorrect(question)" class="badge-result-success">
                                    Correcta
                                </span>
                                <span v-else class="badge-result-danger">
                                    Incorrecta
                                </span>
                                <h6 class="mt-3">
                                    {{ question.question }}
                                </h6>
                                <div class="row mt-3">
                                    <div class="col-12">
                                        <!-- Opción  Respuesta única -->
                                        <div v-if="question.learning_question_type_id === 1">
                                            <ul class="list-unstyled">
                                                <li
                                                    v-for="option in question.options"
                                                    :key="option.id"
                                                    class="d-flex align-items-center my-1"
                                                >
                                                    <span
                                                        class="d-flex align-items-center"
                                                        :class="{
                                                            'text-title-bat correct-answer': isOptionSelected(question, option) && isAnswerCorrect(question, option),
                                                            'text-title-bat incorrect-answer': isOptionSelected(question, option) && !isAnswerCorrect(question, option),
                                                            'correct-answer-not-selected': !isOptionSelected(question, option) && (question.expected_answer === option.option || respuestasCorrectas(question).includes(option))
                                                        }"
                                                    >
                                                        {{ option.option }}

                                                        <img
                                                            v-if="isOptionSelected(question, option)"
                                                            :src="isAnswerCorrect(question, option)
                                                                ? '/img-version2/icons/correct_answer.svg'
                                                                : '/img-version2/icons/wrong_answer.svg'"
                                                            alt="icon-answer"
                                                            class="ms-2"
                                                            style="width: 20px; height: 20px; object-fit: contain;"
                                                        />

                                                        <img
                                                            v-else-if="!isOptionSelected(question, option) && (question.expected_answer === option.option || respuestasCorrectas(question).includes(option))"
                                                            src='/img-version2/icons/correct_answer.svg'
                                                            alt="icon-answer"
                                                            class="ms-2"
                                                            style="width: 20px; height: 20px; object-fit: contain;"
                                                        />
                                                    </span>
                                                </li>
                                            </ul>

                                        </div>
                                        <!-- Opción múltiple -->
                                        <div v-else-if="question.learning_question_type_id === 3">
                                            <ul class="list-unstyled">
                                                <li v-for="option in question.options" :key="option.id" class="d-flex align-items-center my-1">
                                                    <span
                                                        class="d-flex align-items-center"
                                                        :class="{
                                                            'text-title-bat correct-answer': isOptionSelected(question, option) && (Object.values(JSON.parse(question.expected_answer)).includes(option.option)),
                                                            'text-title-bat incorrect-answer': isOptionSelected(question, option) && !isAnswerCorrect(question, option),
                                                            'correct-answer-not-selected': !isOptionSelected(question, option) && (Object.values(JSON.parse(question.expected_answer)).includes(option.option))
                                                        }"
                                                    >
                                                        {{ option.option }}

                                                        <img
                                                            v-if="isOptionSelected(question, option)"
                                                            :src="(Object.values(JSON.parse(question.expected_answer)).includes(option.option))
                                                                ? '/img-version2/icons/correct_answer.svg'
                                                                : '/img-version2/icons/wrong_answer.svg'"
                                                            alt="icon-answer"
                                                            class="ms-2"
                                                            style="width: 20px; height: 20px; object-fit: contain;"
                                                        />

                                                        <img
                                                            v-else-if="!isOptionSelected(question, option) && (Object.values(JSON.parse(question.expected_answer)).includes(option.option))"
                                                            src='/img-version2/icons/correct_answer.svg'
                                                            alt="icon-answer"
                                                            class="ms-2"
                                                            style="width: 20px; height: 20px; object-fit: contain;"
                                                        />
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                        <!-- Opción texto o abierta -->
                                        <div v-else-if="question.learning_question_type_id === 2">
                                            <!-- <h6 :class="{'text-success': isAnswerCorrect(question), 'text-danger': !isAnswerCorrect(question)}"> -->
                                            <h6>Tu respuesta fue:</h6>
                                            <p>{{ question.answers[0].answer }}</p>
                                        </div>
                                    </div>
                                    <!-- <div class="col-3 d-flex justify-content-center aling-items-center">
                                        <img v-if="isAnswerCorrect(question)" class="w-50" src="/img-version2/icons/correct_answer.svg" alt="icon-answer">
                                        <img v-else class="w-50" src="/img-version2/icons/wrong_answer.svg" alt="icon-answer">
                                    </div> -->
                                </div>
                            </div>

                            <div class="footer-feedback bg-light px-3 py-2 rounded-bottom">
                                <h6 class="mt-2">Respuesta:</h6>
                                <p v-if="question && question.answer_justification">{{ question.answer_justification }}</p>
                                <p v-else>Sin asignar</p>
                            </div>
                        </div>
                        <!-- Pregunta seleccion multiple correcta Final -->
                    </div>
                </div>

                <a href="/retos" class="d-flex btn btn-go-challenges">Explorar más retos</a>
            </div>
        </div>
        <div v-else-if="questions <= 0 && loading">
            <initial-loading></initial-loading>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        learning: {
            default: null,
        },
    },
    data() {
        return {
            loading: 0,
            questions: [],
            correct_answers: 0,
            incorrect_answers: 0,
        }
    },
    mounted () {
        this.fetchLearningFeedbackQuizData()
    },
    watch: {
        questions() {
            this.getAnswersSummary();
        }
    },
    methods: {
        fetchLearningFeedbackQuizData() {
        this.loading++
        axios.get(`/learning/${this.learning.id}/quiz/feedback/data`)
            .then(response => {
            const data = response.data;
            this.questions = data.questions;
            this.loading--;
            })
            .catch(error => {
            console.error('Error al obtener los datos:', error);
            });
        },
        // isAnswerCorrect(question) {
        //     const esCorrecta = JSON.parse(question.answers[0].approved) === 1;
        //     return esCorrecta;
        // },
        isAnswerCorrect(question) {
            const type = question.learning_question_type_id;

            if (type === 1 || type === 2) {
                // return question.answers[0]?.answer === question.expected_answer;
                return JSON.parse(question.answers[0].approved) === 1;
            }

            if (type === 3) {
                try {
                    const expectedRaw = JSON.parse(question.expected_answer);
                    const expectedAnswers = Object.values(expectedRaw).map(a => a.toLowerCase()).sort();

                    const lastAnswer = question.answers.at(-1);
                    let selectedAnswers = [];

                    if (lastAnswer) {
                        try {
                            const parsed = JSON.parse(lastAnswer.answer);
                            selectedAnswers = Array.isArray(parsed) ? parsed : [parsed];
                        } catch (e) {
                            selectedAnswers = [];
                        }
                    }

                    selectedAnswers = [...new Set(selectedAnswers.map(a => a.toLowerCase()))].sort();

                    return JSON.stringify(expectedAnswers) === JSON.stringify(selectedAnswers);
                } catch (e) {
                    console.error('Error al parsear JSON:', e);
                    return false;
                }
            }

            return false;
        },
        getAnswersSummary() {
            this.questions.forEach(question => {
            if (question.answers && question.answers.length > 0) {
                const approved = JSON.parse(question.answers[0].approved);
                if (approved === 1) {
                    this.correct_answers++;
                } else {
                    this.incorrect_answers++;
                }
            } else {
                this.incorrect_answers++;
            }
            });
        },
        isAnswerSelected(question, option) {
            return question.answer.includes(option.option);
        },
        isOptionSelected(question, option) {
            if (question.learning_question_type_id === 1) {
                // Pregunta de única selección
                const answer = question.answers[0].answer;
                const selectedOptionId = parseInt(answer);
                return option.id === selectedOptionId;

            } else if (question.learning_question_type_id === 3) {
                // Pregunta de opción múltiple
                const selectedAnswers = JSON.parse(question.answers[0].answer);
                const optionSelected = selectedAnswers.includes(option.option);
                // return selectedAnswers.includes(option.option);
                return optionSelected;
            }
            return false;
        },
        porcentajeAciertos() {
        const totalQuestions = this.questions.length;
        const correctQuestions = this.questions.filter((question) => {
            return this.isAnswerCorrect(question);
        }).length;
        return ((correctQuestions / totalQuestions) * 100).toFixed(2);
        },
        respuestasCorrectas(question) {
            if (question.learning_question_type_id === 1 || question.learning_question_type_id === 2) {
                return question.expected_answer;
            }

            if (question.learning_question_type_id === 3) {
                let expectedAnswers = [];

                try {
                    const parsed = JSON.parse(question.expected_answer);
                    if (Array.isArray(parsed)) {
                        expectedAnswers = parsed;
                    } else {
                        console.warn('expected_answer no es un array:', parsed);
                    }
                } catch (e) {
                    console.error('Error al parsear expected_answer:', e);
                }

                const opciones = Array.isArray(question.options) ? question.options : [];

                const respuestasCorrectas = opciones.filter(option =>
                    expectedAnswers.includes(option.option)
                );

                return respuestasCorrectas;
            }

            return [];
        },
        returnView(){
            window.location.href = '/retos?page=1&option=learning';
        },
    },
}
</script>

<style scoped>
    .container-result {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 16px;
        border: 1px solid #E4E4E4;
        border-radius: 12px;
        background-color: #fff;
        width: auto;
        box-sizing: border-box;
    }

    .subtitle {
        font-family: gothamlight, sans-serif;
        font-size: 16px;
        line-height: 24px;
        color: #464646;
    }

    .card-feedback {
        padding: 20px;
        border-radius: 16px;
        background-color: #FBFBFB;
        width: 100%;
    }

    .card-content-feedback {
        display: flex;
        margin-bottom: 10px;
    }

    .section-divider-top {
        display: flex;
        flex-direction: column;
        text-align: left;
        flex: 1;
    }

    .section-divider-top h4 {
        margin: 0;
        font-family: gothamlight, sans-serif;
        font-size: 12px;
        line-height: 16px;
        color: #464646;
    }

    .section-divider-top .value-percentage {
        font-family: gothambold, sans-serif;
        font-size: 16px;
        line-height: 24px;
    }

    .correct {
        color: #83D300;
    }

    .incorrect {
        color: #FF0000;
    }

    .section-divider-bottom {
        display: flex;
    }

    .section-divider-bottom .item-divider {
        display: flex;
        flex-direction: column;
        text-align: left;
        flex: 1;
    }

    .section-divider-bottom .item-divider .label-status {
        font-family: gothamlight, sans-serif;
        font-size: 12px;
        line-height: 16px;
        color: #464646;
    }

    .section-divider-bottom .item-divider .number-status {
        font-family: gothambold, sans-serif;
        font-size: 16px;
        line-height: 24px;
    }

    .footer-feedback h6 {
        font-family: gothambold, sans-serif;
        font-size: 16px;
        line-height: 24px;
        color: #464646;
    }

    .footer-feedback p {
        font-family: gothamlight, sans-serif;
        font-size: 16px;
        line-height: 24px;
        color: #464646;
    }

    .feedback-box {
        border-radius: 10px;
        background-color: #fff;
    }

    .feedback-box.feedback-border-success {
        border-left: 8px solid #00660A;
    }

    .feedback-box.feedback-border-danger {
        border-left: 8px solid #FF0000;
    }

    .feedback-box .badge-result-success {
        background-color: #83D300;
        color: #fff;
        font-size: 12px;
        font-family: gothamlight, sans-serif;
        line-height: 16px;
        padding: 4px;
        border-radius: 4px;
    }

    .feedback-box .badge-result-danger {
        background-color: #FF0000;
        color: #fff;
        font-size: 12px;
        font-family: gothamlight, sans-serif;
        line-height: 16px;
        padding: 4px;
        border-radius: 4px;
    }

    .btn-go-challenges {
        font-family: 'Segoe UI', sans-serif;
        border: 1.31px solid #204F9A;
        color: #004F9F;
        font-weight: 700;
        gap: 10px;
        width: 100%;
        max-width: 100%;
        height: 40px;
        border-radius: 8px;
        padding: 8px 14px;
        background-image: none;
        background-color: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
    }

    .btn-go-challenges:hover {
        background-color: #fff;
        color: #204F9A;
        box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    }

    .incorrect-answer {
        background-color: #FFDED9 !important;
        color: #FF0000 !important;
        border-radius: 4px;
        padding: 8px;
        gap: 24px;
    }

    .correct-answer {
        background-color: #F1FFE4 !important;
        color: #83D300 !important;
        border-radius: 4px;
        padding: 8px;
        gap: 24px;
    }

    .correct-answer-not-selected {
        background-color: #FFF !important;
        border-radius: 4px;
        padding: 8px;
        gap: 24px;
    }

    @media (min-width: 768px) {
        .container-result {
            width: 520px;
            margin: 0;
        }

        .card-feedback {
            padding: 20px;
        }

        .card-content-feedback {
            flex-direction: row;
            justify-content: space-between;
        }

        .section-divider-top {
            flex-direction: row;
            align-items: baseline;
            gap: 8px;
            margin-bottom: 0;
        }

        .section-divider-top h4 {
            font-size: 16px;
            line-height: 24px;
        }

        .section-divider-bottom {
            flex-direction: row;
            justify-content: space-between;
        }

        .section-divider-bottom .item-divider {
            flex-direction: row;
            align-items: baseline;
            gap: 8px;
            margin-bottom: 0;
        }

        .section-divider-bottom .item-divider .label-status {
            font-size: 16px;
            line-height: 24px;
        }

        .btn-go-challenges
        {
            width: 288px;
        }
    }
</style>
